<template>
  <div class="tags-wrapper">
    <tag-manager :resourceType='messageType' :resource='message' @reload-list="success" />

    <div class="tag-dropdown-column">
      <div class="existing-tags-wrapper" :class="tag.color" v-for="tag in message.tags">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label class="btn active">
            <router-link :to="{name: 'tag', params: { id: tag.id }}">
              {{tag.name}}
            </router-link>
          </label>

          <label class="btn" @click.prevent="removeConnectedTag(tag)">
            <i class="fa fa-remove"></i>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _tag_manager from "./_tags_manager"
  export default {
    components: {
      'tag-manager': _tag_manager
    },
    props: ['message', 'messageType'],
    methods: {
      success() {
        this.$emit('success')
      },
      removeConnectedTag(tag) {
        if (this.$props.messageType === 'documentResponse') {
          this.store.removeConnectedTag(tag.id, {document_response_id: this.$props.message.id}).then(() => {
            this.store.sendMetrics({
              name: 'remove_tag_from_document_response',
              params: this.$route.params,
              path: this.$route.fullPath
            })
            this.success()
          })
        } else if (this.$props.messageType === 'documentRequest') {
          this.store.removeConnectedTag(tag.id, {document_request_id: this.$props.message.id}).then(() => {
            this.store.sendMetrics({
              name: 'remove_tag_from_document_request',
              params: this.$route.params,
              path: this.$route.fullPath
            })
            this.success()
          })
        } else if (this.$props.messageType === 'automatedEmail') {
          this.store.removeConnectedTag(tag.id, { sent_email_id: this.$props.message.id}).then(() => {
            this.store.sendMetrics({
              name: 'remove_tag_from_automated_email',
              params: this.$route.params,
              path: this.$route.fullPath
            })
            this.success()
          })
        } else if (this.$props.messageType === 'recordMessage') {
          this.store.removeConnectedTag(tag.id, { record_message_id: this.$props.message.id}).then(() => {
            this.store.sendMetrics({
              name: 'remove_tag_from_record_message',
              params: this.$route.params,
              path: this.$route.fullPath
            })
            this.success()
          })
        }
      }
    }
  }
</script>
<style lang="sass" scoped>
  .tags-wrapper
    display: flex
</style>
